const OnboardingPortalTableHeaders = ({
    headers,
    t,
}: {
    headers: string[];
    t: (key: string) => string;
}) => {
    return (
        <thead>
            <tr>
                {headers.map((header) => (
                    <th key={header}>{t(header)}</th>
                ))}
            </tr>
        </thead>
    );
};

export default OnboardingPortalTableHeaders;